import { render } from "./teacherDetail.vue?vue&type=template&id=3ee5324b&scoped=true"
import script from "./teacherDetail.vue?vue&type=script&lang=js"
export * from "./teacherDetail.vue?vue&type=script&lang=js"

import "./teacherDetail.vue?vue&type=style&index=0&id=3ee5324b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee5324b"]])

export default __exports__